import {rootAction} from "../apiAction";

export const REQUEST_GET_REQUEST_LIST = 'REQUEST_GET_REQUEST_LIST';
export const SUCCESS_GET_REQUEST_LIST = 'SUCCESS_GET_REQUEST_LIST';
export const FAILURE_GET_REQUEST_LIST = 'FAILURE_GET_REQUEST_LIST';

export const getRequestList = (data, page, size) => dispatch => {
    return dispatch(rootAction(
        'POST',
        `/notary/esb/list?page=${page -1}&size=${size}&sort=createDateTime,desc`,
      data,
        {
            request: REQUEST_GET_REQUEST_LIST,
            success: SUCCESS_GET_REQUEST_LIST,
            failure: FAILURE_GET_REQUEST_LIST
        }
    ));
}

// /notary/esb/list?page=${page}&size=${size}